import SegmentUtils from 'utils/segment';
/* eslint-disable camelcase */
export default function trackAppleMapsExperience({ searchType, }) {
    const properties = {
        search_type: searchType,
        in_enhanced_experiment: true,
    };
    SegmentUtils.page({
        name: 'Apple Maps Experience Started',
        properties,
    });
}
